var exports = {
  "k": "x804f0401--fc3d78--container",
};

module.exports = exports;
